import { useChatbotStore } from "../zustand/store";

export const GentooGreetingView = (props) => {
    const { isDisplayOpen } = props;
    const { chatbot } = useChatbotStore();
    const openImageSource = chatbot?.avatar?.loadingAsset?.expand || '/img/units/gentoo-onboarding.gif';
    const shrinkImageSource = chatbot?.avatar?.loadingAsset?.shrink || '/img/units/gentoo-onboarding-shrink.gif';
    return (
        isDisplayOpen ?
        <div style={{ width: '100%', height: '182px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={openImageSource} width={320} height={142} alt='gentoo-greeting' />
        </div> :
        <div style={{ width: '100%', height: '82px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={shrinkImageSource} width={320} height={42} alt='gentoo-greeting' />
        </div>
    )
}   

export const GentooLoadingView = (props) => {
    const { isDisplayOpen } = props;
    return (
        isDisplayOpen ?
        <div style={{ width: '100%', height: '182px', textAlign: 'center', backgroundColor: '#fff' }}>
            <img src='/img/units/searching-anime.gif' width={320} height={142} alt='gentoo-loading' />
        </div> :
        <div style={{ width: '100%', height: '82px', textAlign: 'center', backgroundColor: '#fff' }}>
            <img src='/img/units/searching-anime-shrink.gif' width={320} height={42} alt='gentoo-loading' />
        </div>
    )
}